import { render, staticRenderFns } from "./admin-side-menu.vue?vue&type=template&id=d9f626b6&scoped=true&"
import script from "./admin-side-menu.vue?vue&type=script&lang=js&"
export * from "./admin-side-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f626b6",
  null
  
)

export default component.exports